// 一般ユーザー系
// 一般ユーザー トップ
import CommonTop from '@/components/Common/Top/CommonTop'
// 一般ユーザー ログイン
import CommonLogin from '@/components/Common/Login/CommonLogin'
// 一般ユーザー マイページ
import CommonMyPage from '@/components/Common/MyPage/CommonMyPage'
// パスワード変更　変更画面
import CommonChangePassword from '@/components/Common/ChangePassword/CommonChangePassword'
// パスワード変更　変更完了画面
import CommonChangePassword2 from '@/components/Common/ChangePassword/CommonChangePassword2'
// 予約キャンセル　キャンセル画面
import CommonConfirmCancel from '@/components/Common/ConfirmCancel/CommonConfirmCancel'
// 予約キャンセル　キャンセル完了画面
import CommonConfirmCancel2 from '@/components/Common/ConfirmCancel/CommonConfirmCancel2'
// 予約情報詳細
import CommonReserveDetail from '@/components/Common/ReserveDetail/CommonReserveDetail'
// 一般ユーザー パスワードを忘れた方用ページ　再発行メール送信画面
import CommonForgetPassword from '@/components/Common/ForgetPassword/CommonForgetPassword'
// 一般ユーザー パスワードを忘れた方用ページ　再発行メール送信完了画面
import CommonForgetPassword2 from '@/components/Common/ForgetPassword/CommonForgetPassword2'
// 一般ユーザー 新規健保予約
import CommonNewHealthInsurance from '@/components/Common/NewHealthInsurance/CommonNewHealthInsurance'
// 一般ユーザー コース選択
import CommonSelectCourse from '@/components/Common/SelectCourse/CommonSelectCourse'
// 一般ユーザー オプション選択
import CommonSelectOption from '@/components/Common/SelectOption/CommonSelectOption'
// 一般ユーザー カレンダー選択
import CommonSelectCalender from '@/components/Common/SelectCalender/CommonSelectCalender'
// 一般ユーザー 予約情報入力
import CommonInputReserveInfo from '@/components/Common/InputReserveInfo/CommonInputReserveInfo'
// 一般ユーザー 予約確認
import CommonConfirmReserveInfo from '@/components/Common/ConfirmReserveInfo/CommonConfirmReserveInfo'
// 一般ユーザー　予約確定
import CommonReserveResult from '@/components/Common/CommonReserveResult/CommonReserveResult'

export default [
  // 一般ユーザー トップ
  {
    // http://localhost:8080/#/CommonTop/「各医療機関URLパラメーター用識別子」
    path: '/CommonTop/:routeParam',
    name: 'CommonTop',
    component: CommonTop
  },
  // 一般ユーザー ログイン
  {
    // http://localhost:8080/#/CommonLogin/「各医療機関URLパラメーター用識別子」
    path: '/CommonLogin/:routeParam',
    name: 'CommonLogin',
    component: CommonLogin
  },
  // 一般ユーザー マイページ
  {
    path: '/CommonMyPage',
    name: 'CommonMyPage',
    component: CommonMyPage
  },
  // 一般ユーザー パスワード変更 変更画面
  {
    path: '/CommonChangePassword',
    name: 'CommonChangePassword',
    component: CommonChangePassword
  },
  // 一般ユーザー パスワード変更 変更完了画面
  {
    path: '/CommonChangePassword2',
    name: 'CommonChangePassword2',
    component: CommonChangePassword2
  },
  // 一般ユーザー 予約キャンセル　キャンセル画面
  {
    path: '/CommonConfirmCancel',
    name: 'CommonConfirmCancel',
    component: CommonConfirmCancel
  },
  // 一般ユーザー 予約キャンセル　キャンセル完了画面
  {
    path: '/CommonConfirmCancel2',
    name: 'CommonConfirmCancel2',
    component: CommonConfirmCancel2
  },
  // 一般ユーザー 予約情報詳細
  {
    path: '/CommonReserveDetail',
    name: 'CommonReserveDetail',
    component: CommonReserveDetail
  },
  // 一般ユーザー パスワードを忘れた方用ページ　再発行メール送信画面
  {
    path: '/CommonForgetPassword',
    name: 'CommonForgetPassword',
    component: CommonForgetPassword
  },
  // 一般ユーザー パスワードを忘れた方用ページ　再発行メール送信完了画面
  {
    path: '/CommonForgetPassword2',
    name: 'CommonForgetPassword2',
    component: CommonForgetPassword2
  },
  // 一般ユーザー 新規健保予約
  {
    path: '/CommonNewHealthInsurance',
    name: 'CommonNewHealthInsurance',
    component: CommonNewHealthInsurance
  },
  // 一般ユーザー コース選択
  {
    path: '/CommonSelectCourse',
    name: 'CommonSelectCourse',
    component: CommonSelectCourse
  },
  // 一般ユーザー オプション選択
  {
    path: '/CommonSelectOption',
    name: 'CommonSelectOption',
    component: CommonSelectOption
  },
  // 一般ユーザー カレンダー選択
  {
    path: '/CommonSelectCalender',
    name: 'CommonSelectCalender',
    component: CommonSelectCalender
  },
  // 一般ユーザー 予約情報入力
  {
    path: '/CommonInputReserveInfo',
    name: 'CommonInputReserveInfo',
    component: CommonInputReserveInfo
  },
  // 一般ユーザー 予約情報確認
  {
    path: '/CommonConfirmReserveInfo',
    name: 'CommonConfirmReserveInfo',
    component: CommonConfirmReserveInfo
  },
  // 一般ユーザー 予約確定
  {
    path: '/CommonReserveResult',
    name: 'CommonReserveResult',
    component: CommonReserveResult
  },
]



// WEBPACK FOOTER //
// ./src/router/commonRoutes.js